// Creates an array of variant objects from mapping and searchParams
import _ from 'lodash';
import { AppStateMachineContext } from '../../types';

import { formatNumber } from './formatters/formatNumber';
import { parseDateToISO } from './formatters/parseDateToISO';
import { parseYearMonthToDateObject } from './formatters/parseYearMonthToDateObject';

type FormatterNames = 'date' | 'isoDate' | 'price';
export type MappingConfig = { paramName: string; formatter?: FormatterNames };

type FormatterFunction = (
  value: string | number | unknown,
  mapping?: Record<string, MappingConfig>,
  searchParams?: Record<string, unknown>
) => unknown;

const formatters: Record<FormatterNames, FormatterFunction> = {
  date: parseYearMonthToDateObject,
  isoDate: parseDateToISO,
  price: formatNumber,
};

export function saveDefaultDataFromSearchParams(
  context: AppStateMachineContext,
  mapping: Record<string, MappingConfig>,
): AppStateMachineContext {
  const { searchParams } = context;

  if (!searchParams) return context;

  // Deep clone context to avoid mutation
  const newContext = _.cloneDeep(context);

  Object.entries(mapping)
    .forEach(([contextPath, paramConfig]) => {
      const { paramName, formatter: formatterName } = paramConfig;

      let value = _.get(searchParams, paramName);

      if (formatterName && formatters[formatterName]) {
        value = formatters[formatterName](value, mapping, searchParams);
      }

      if (typeof value !== 'undefined') {
        _.set(newContext, contextPath, value);
      }
    });

  return newContext;
}
